/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 8
// module chunks = 1